import {
    moneyRanking,
    winRanking,
    combatRanking,
    weekRanking,
} from '../../../api/wz/ranking'

import {assign, getServerTime, dataFormat } from '../../../utils/base'
import { update } from '../../../utils/vuex'

const state = {
    moneyRankingList    : null,
    winRankingList      : null,
    combatRankingList   : null,
    weekRankingList     : null,
}
export default {
    namespaced: true,
    state,    
    getters: {
        moneyRankingList(state) {
            return state.moneyRankingList || []
        },
        winRankingList(state) {
            return state.winRankingList || []
        },
        combatRankingList(state) {
            return state.combatRankingList
        },
        weekRankingList(state) {
            return state.weekRankingList || []
        },
    },

    actions: {
        async loadMoneyRanking ({commit}, query){
            const R = await moneyRanking(query)
            let moneyRankingList = R.list
            
            commit('update', {
                moneyRankingList
            })    
            return R 
        },
        async loadWinRanking ({commit}, query){
            const R = await winRanking(query)
            let winRankingList = R.list
            
            commit('update', {
                winRankingList
            })
            return R 
        },
        async loadCombatRankingList ({commit}, query){
            const R = await combatRanking({
                date : dataFormat(getServerTime(), 'yyyy-MM-dd'),
                start : 0,
                pageNum : 50
            })
            let combatRankingList = {
                rankList : R.rankList || [],
                myBetInfo : R.myBetInfo,
            }            
            commit('update', {
                combatRankingList
            })
            return R 
        },
        async loadWeekRankingList ({commit}, query){
            const R = await weekRanking(query)
            let weekRankingList = R.list
            
            commit('update', {
                weekRankingList
            })
            return R 
        },
    },


    mutations: {
        update,
    }
}